import { useModal } from '@ebay/nice-modal-react'
import { type MouseEvent, useEffect, useRef, useState } from 'react'
import Draggable, { type DraggableEvent } from 'react-draggable'
import { useTranslation } from 'react-i18next'

import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import LoginModal from '../common/log-in-modal'
import Icon from '../icon'

interface FavoritesProps {
  noOfFavorites: number
  category: string
  onClick: () => void
}

const Favorites = ({ category, onClick, noOfFavorites }: FavoritesProps) => {
  const username = useBoundStore(state => state.user.username)
  const { geoCheck } = useGeoCheck()
  const logInModal = useModal(LoginModal)
  const { t } = useTranslation('casino')
  const [position, setPosition] = useState({ clientX: 0, clientY: 0 })
  const [timeStamp, setTimeStamp] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const nodeRef = useRef(null)

  const onStop = (e: DraggableEvent) => {
    let clientX = 0
    let clientY = 0
    if ((e as TouchEvent).changedTouches) {
      const { changedTouches } = e as TouchEvent
      clientX = changedTouches[0].clientX
      clientY = changedTouches[0].clientY
    } else {
      clientX = (e as MouseEvent).clientX
      clientY = (e as MouseEvent).clientY
    }
    const dragTime = e.timeStamp - timeStamp
    if (
      (clientX === position.clientX && clientY === position.clientY) ||
      dragTime < 100
    ) {
      if (!username) {
        geoCheck(logInModal.show)
      }
      onClick()
    }
  }

  const onStart = (e: DraggableEvent) => {
    if ((e as TouchEvent).changedTouches) {
      const { changedTouches, timeStamp } = e as TouchEvent
      setPosition({
        clientX: changedTouches[0].clientX,
        clientY: changedTouches[0].clientY,
      })
      setTimeStamp(timeStamp)
    } else {
      const { clientX, clientY, timeStamp } = e as MouseEvent
      setPosition({ clientX: clientX, clientY: clientY })
      setTimeStamp(timeStamp)
    }
  }

  useEffect(() => {
    if (category === 'favorites') {
      setIsOpen(true)
      setTimeout(() => setIsOpen(false), 3000)
    } else {
      setIsOpen(false)
    }
  }, [category])

  return (
    <Draggable
      onStart={onStart}
      onStop={onStop}
      axis="y"
      bounds="#drag-boundary"
      nodeRef={nodeRef}>
      <div
        className="fixed top-[calc(50%_-_25px)] z-[15] right-0"
        ref={nodeRef}>
        <div
          className={classNames(
            'flx-str-ctr h-[50px] z-[15] bg-[rgba(0,0,0,0.7)] text-[white] transition-all duration-[0.3s]',
            'ease-[ease-in-out] cursor-ns-resize pl-4 pr-3 py-0 rounded-tl-[25px] rounded-bl-[25px]',
          )}
          style={{
            transform: isOpen ? 'translateX(0px)' : 'translateX(81px)',
          }}>
          <div className="w-[25px] relative flex">
            <Icon id="star-2" opacity="0.6" width="25" height="30" />
            {noOfFavorites > 0 && (
              <span className="flx-ctr absolute text-[white] w-2.5 h-2.5 bg-[rgb(176,31,35)] text-[7px] rounded-[50%] -right-1 -top-1">
                {noOfFavorites}
              </span>
            )}
          </div>
          <p
            className="transition-all duration-[0.3s] ease-[ease-in-out]"
            style={{
              color: 'rgb(204, 204, 204)',
              marginLeft: '7px',
              opacity: isOpen ? 1 : 0,
            }}>
            {t('favorites')}
          </p>
        </div>
      </div>
    </Draggable>
  )
}

export default Favorites
